<div class="theme-picker-container">
  <button
    type="button"
    class="theme-picker-btn"
    [attr.popovertarget]="popoverId"
    aria-label="Switch theme"
    title="Switch theme"
  >
    <svg
      class="theme-picker-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1792 1792"
      fill="currentColor"
      aria-hidden="true"
    >
      <path transform="translate(0 1536) scale(1 -1)" d="M1615 1536q70 0 122.5 -46.5t52.5 -116.5q0 -63 -45 -151q-332 -629 -465 -752q-97 -91 -218 -91q-126 0 -216.5 92.5t-90.5 219.5q0 128 92 212l638 579q59 54 130 54zM706 502q39 -76 106.5 -130t150.5 -76l1 -71q4 -213 -129.5 -347t-348.5 -134q-123 0 -218 46.5t-152.5 127.5t-86.5 183t-29 220q7 -5 41 -30t62 -44.5t59 -36.5t46 -17q41 0 55 37q25 66 57.5 112.5t69.5 76t88 47.5t103 25.5t125 10.5z"></path>
    </svg>
  </button>

  <div
    [id]="popoverId"
    popover="auto"
    class="theme-picker-dropdown"
    role="listbox"
    aria-label="Theme selection"
    (toggle)="onPopoverToggle($any($event))"
  >
    @for (theme of availableThemes; track theme.id) {
      <div
        class="theme-option"
        [class.active]="themeService.currentTheme() === theme.id"
        (click)="selectTheme(theme.id)"
        (keydown.enter)="selectTheme(theme.id)"
        tabindex="0"
        role="option"
        [attr.aria-selected]="themeService.currentTheme() === theme.id"
      >
        <svg class="theme-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path [attr.d]="iconPath(theme.icon)"></path>
        </svg>
        <span class="theme-name">{{ theme.name }}</span>
        @if (themeService.currentTheme() === theme.id) {
          <svg class="theme-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        }
      </div>
    }
  </div>
</div>
